import React from 'react';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import store from './store';
import { Provider } from 'mobx-react';

const Enter = () => {
    return (
        <>
            <Provider store={store}>
                <App />
            </Provider>
        </>
    );
};

const container = document.getElementById('root');

let root = createRoot(container);
root.render(<Enter />);

reportWebVitals();
